var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"nav-buttons"},_vm._l((_vm.routerArr),function(item,index){return _c('router-link',{key:index,staticClass:"nav-link",attrs:{"to":item.path,"active-class":"active"}},[_vm._v(_vm._s(item.title))])}),1)]),_c('div',{staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }